import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../../../components/toast/useToast";
import OdpojeniService, {
    DruhOdpojeni, OdpojeniNastaveni, OdpojeniNastaveniRequest, OdpojeniTichyRezim, OdpojeniTichyRezimRequest,
    OdpojeniVypadek,
} from "./OdpojeniService";

export const ODPOJENI_KEYS = {
    nastaveni: ["odpojeniNastaveni"] as const,
    tichyRezim: ["odpojeniTichyRezim"] as const,
    vypadky: (druh: DruhOdpojeni | '') => ["odpojeniVypadky", druh] as const,
};

export const useOdpojeniNastaveniQuery = () =>
    useQuery<OdpojeniNastaveni[], Error>({ queryKey: ODPOJENI_KEYS.nastaveni, queryFn: OdpojeniService.nastaveni });

/** Tabulka výpadků se obnovuje po minutě, jen když je stránka vidět. */
export const useOdpojeniVypadkyQuery = (druh: DruhOdpojeni | '') =>
    useQuery<OdpojeniVypadek[], Error>({
        queryKey: ODPOJENI_KEYS.vypadky(druh),
        queryFn: () => OdpojeniService.vypadky(druh || undefined),
        refetchInterval: 60000,
        refetchIntervalInBackground: false,
    });

export const useUlozOdpojeniMutation = () => {
    const { showToast } = useToast();
    const qc = useQueryClient();
    return useMutation<OdpojeniNastaveni, Error, { druh: DruhOdpojeni; data: OdpojeniNastaveniRequest }>({
        mutationFn: ({ druh, data }) => OdpojeniService.uloz(druh, data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ODPOJENI_KEYS.nastaveni });
            showToast("Nastavení bylo uloženo", "success");
        },
        onError: (e) => showToast(e.message || "Nastavení se nepodařilo uložit", "error"),
    });
};

export const useOdpojeniTichyRezimQuery = () =>
    useQuery<OdpojeniTichyRezim, Error>({ queryKey: ODPOJENI_KEYS.tichyRezim, queryFn: OdpojeniService.tichyRezim });

export const useUlozTichyRezimMutation = () => {
    const { showToast } = useToast();
    const qc = useQueryClient();
    return useMutation<OdpojeniTichyRezim, Error, OdpojeniTichyRezimRequest>({
        mutationFn: (data) => OdpojeniService.ulozTichyRezim(data),
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ODPOJENI_KEYS.tichyRezim });
            showToast("Tichý režim byl uložen", "success");
        },
        onError: (e) => showToast(e.message || "Tichý režim se nepodařilo uložit", "error"),
    });
};
